import { USER_DECLINED } from '../constants/InboxErrors';
import { PERMISSIONS_ERROR } from './ActionTypes';
export const userDeclined = () => ({
  type: PERMISSIONS_ERROR,
  payload: {
    message: USER_DECLINED
  }
});